import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=25175223&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=25175223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25175223",
  null
  
)

export default component.exports